import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 relative overflow-hidden bg-gradient-to-br from-white via-slate-50 to-blue-50">
      <SEO
        title="Page Not Found | VANCO"
        description="The page you're looking for doesn't exist. Explore VANCO's AI services, industries and case studies."
        path="/404"
        noindex
      />
      {/* Background Shapes */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#243b7f]/5 rounded-full blur-3xl opacity-50" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#f7c550]/10 rounded-full blur-3xl" />
      
      <div className="text-center relative z-10 max-w-2xl mx-auto">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-9xl font-black text-[#243b7f] mb-4 tracking-tighter drop-shadow-sm">404</h1>
          <div className="w-24 h-1.5 bg-[#f7c550] mx-auto rounded-full mb-8" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-6 font-['Manrope']">
            Oops! Page vanished into thin air.
          </h2>
          <p className="text-lg text-slate-600 mb-10 leading-relaxed max-w-lg mx-auto">
            The page you're looking for was moved, removed, or never existed in the first place. Don't worry, we'll help you find your way back.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/">
              <Button size="lg" className="bg-[#243b7f] hover:bg-[#1e3a8a] text-white rounded-full px-8 py-6 text-lg transition-all duration-300 hover:scale-105 shadow-xl shadow-blue-900/10">
                <Home className="mr-2 h-5 w-5" />
                Go to Homepage
              </Button>
            </Link>
            <Button 
              variant="outline" 
              size="lg" 
              onClick={() => window.history.back()}
              className="border-[#243b7f]/20 text-[#243b7f] hover:bg-[#243b7f]/5 rounded-full px-8 py-6 text-lg"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Go Back
            </Button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
